export enum GlobalPresenceOption {
  NONE = "NONE",
  MULTI_NATIONAL = "MULTI_NATIONAL",
  BY_LOCATION = "BY_LOCATION",
}

export enum LocationTypeOption {
  COUNTRY = "COUNTRY",
  REGION = "REGION",
}

export type GlobalPresenceDefinition = {
  value: GlobalPresenceOption;
  label: string;
};

export const GLOBAL_PRESENCE_OPTIONS: GlobalPresenceDefinition[] = [
  {
    value: GlobalPresenceOption.NONE,
    label: "No global presence filter",
  },
  {
    value: GlobalPresenceOption.MULTI_NATIONAL,
    label: "Filter for hierarchies that are multi-national",
  },
  {
    value: GlobalPresenceOption.BY_LOCATION,
    label: "Filter for hierarchies by location",
  },
];

export const LOCATION_TYPE_OPTIONS = [
  { value: LocationTypeOption.COUNTRY, label: "Country" },
  { value: LocationTypeOption.REGION, label: "Region" },
];

export const MATCH_COUNT_OPTIONS = [
  { value: "ANY", label: "Any" },
  { value: "ALL", label: "All" },
  { value: "AT_LEAST", label: "At least", category: true },
  ...Array.from({ length: 10 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  })),
];
